import { createBrowserHistory, createMemoryHistory, History } from 'history'

let history: History = createMemoryHistory()
if (typeof window !== 'undefined') {
  history = createBrowserHistory()
}

export default history

export const createServerHistory = (url: string): History =>
  createMemoryHistory({
    initialEntries: [url],
  })
